import React from 'react';
import {FaWhatsapp} from "react-icons/fa";

const WhatsApp = ({number, className}) => {
    const openWhatsApp = (e) => {
        e.preventDefault();
        if (number){
            if (number.length === 11) window.open("https://wa.me/55" + number)

            if (number.length >= 13){
                const formatedPhone = number.replace(/\D/g, '')
                window.open("https://wa.me/55" + formatedPhone)
            }
        }
    }

    return (
        <div className={className} onClick={(e) => openWhatsApp(e)}>
            <FaWhatsapp />
        </div>
    );
};

export default WhatsApp;